module.exports = function(app) {
	app.controller('pages.register.chip14Confirmation', ['$state', '$scope', '$window', '$filter', 'registrationUser', 'registration', 'registerNotifications', 'contentResourceServices','coremetrics',
        function($state, $scope, $window, $filter, registrationUser, registration, registerNotifications, contentResourceServices,coremetrics) {

            coremetrics.startConversion('CHIP STEP', 'REGISTRATION');

            $scope.scrollTo('chevron-container');

            $scope.disableForm = false;
            $scope.user = registrationUser;
            $scope.chevron.parameters = { user : $scope.user };
            $scope.showExitButton = false;
            $scope.notifications = [];

            $scope.updateCurrentChevronStep();

            var filterFn = registration.notificationFilter('alert', 'register.chip14Confirmation');
            contentResourceServices.updateResourcesAsync(registerNotifications, filterFn, "Bluecore Notification").then(function(items){
                $scope.notifications = items;
            });

            $scope.nextStep = function() {
                $scope.currentNotification = '';

                if ($scope.chipRegisterForm && $scope.chipRegisterForm.$valid) {
                    coremetrics.elementTag('REGISTRATION:CHIP NEXT', 'REGISTRATION');

                    $scope.disableForm = true;
                    $scope.currentNotification = registration.notifications.verifyPleaseWait;

                    $scope.user.brand = $scope.brandData.sharedBrandCode;

                    registration.identifyUser($scope.user).then(function(data) {
                        $scope.user = data.user;
                        $scope.disableForm = false;
                        $scope.currentNotification = '';

                        coremetrics.finishConversion('CHIP STEP', 'REGISTRATION');
                        $state.go($scope.getNextStateFromChevron(), { user : $scope.user, identifyResponse: data.response } );

                    }, function(error) {
                        var nf = $filter('filter')($scope.notifications, { id: error.returnCodeDescription });
                        $scope.currentNotification = (nf.length > 0 ? error.returnCodeDescription : registration.notifications.defaultError);

                        coremetrics.pageviewTag('REGISTRATION CHIP CONFIRMATION:' + $scope.currentNotification, 'REGISTRATION');

                        if (error.chipCounter >= 3) {
                            $scope.showExitButton = true;
                            $scope.chipRegisterForm.$setPristine();
                            $scope.chipRegisterForm.$setUntouched();
                            $scope.user = {};
                            $scope.chevron.parameters = {};
                            //disable the chevron (Make the current step appear to have no valid steps for navigation).
                            $scope.chevron.steps[$scope.chevron.step-1].validSteps = [ 0 ];

                        } else {
                            $scope.disableForm = false;
                        }
                    });
                }
            };

            $scope.cancelButton = function() {
                coremetrics.elementTag('REGISTRATION:CHIP BACK', 'REGISTRATION');
                $scope.scrollTo('chevron-container');
                $state.go($scope.getPreviousStateFromChevron(),  $scope.chevron.parameters);
            };

            $scope.exitButton = function() {
                coremetrics.elementTag('REGISTRATION:CHIP EXIT', 'REGISTRATION');
                $window.location = '/member/home/';
            };

		}
	]);
};
